module.exports = __webpack_public_path__ + "img/ic-log-in-purple.a62e64f6.svg";